import * as React from 'react';
import Loader from '../_common/loader';
import APIManager from '../../utilities/api-manager';

const DatasetVisualizationContainer = React.lazy(() => import('../dataset-section-components/dataset-visualization'));

const datasetVisualizationSection = function DatasetVisualizationSection({
    isBundle,
    isLoggedIn,
    isTableauSessionCreated,
    scrollTo,
    dataSectionType,
    dataVisualization
}: DatasetVisualizationSectionProps) {
    const [embedContentArray, setEmbedContentArray] = React.useState<PowerBIEmbedContent[]>([]);

    React.useEffect(() => {
        const fetchPowerBIEmbedContentData = async (id: string) => {
            const response = await APIManager.getPowerBIEmbedInfo(id);
            return response.data;
        };
        let powerbiViz: any[] = [];

        if (dataVisualization) {
            powerbiViz = dataVisualization.filter(viz => viz.VisualizationType === 'POWERBI');
        }

        const fetchAllEmbedContent = async () => {
            try {
                const results = await Promise.all(powerbiViz.map(viz => fetchPowerBIEmbedContentData(viz.ReportId)));
                setEmbedContentArray(results);
            } catch (error) {
                console.error('Failed to fetch PowerBI Embed Content Data:', error);
            }
        };
        fetchAllEmbedContent();
    }, []);

    return (
        <section id={dataSectionType} className="dataset-data-section page-section">
            <React.Suspense fallback={<Loader minHeight="700px" />}>
                <DatasetVisualizationContainer isTableauSessionCreated={isTableauSessionCreated} isLoggedIn={isLoggedIn} isBundle={isBundle} scrollTo={scrollTo} dataSectionType={dataSectionType} dataVisualization={dataVisualization} powerBIEmbedContent={embedContentArray} />
            </React.Suspense>
        </section>
    );
};

export default React.memo(datasetVisualizationSection);
